module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/clinic-location.json
// module id = 369
// module chunks = 20493477750841